import React, { useState } from 'react';

import { joinHackathon } from '../../services/hackathon.service';
import Typography from '@mui/material/Typography/Typography';
import Stack from '@mui/material/Stack/Stack';
import Alert from '@mui/material/Alert/Alert';
import TextField from '@mui/material/TextField/TextField';
import Button from '@mui/material/Button/Button';

export const JoinHackathon = ({
    hackathonId,
    needsInviteCode
}: {
    hackathonId: string,
    needsInviteCode: boolean
}) => {

    const codeQP = new URLSearchParams(window.location.search).get('code');
    // opened from a judge invite link: no invite code, and joining makes you a judge
    const judgeCode = new URLSearchParams(window.location.search).get('judge') || undefined;

    const [inviteCode, setInviteCode] = useState<string>(codeQP || '');
    const [error, setError] = useState<string>('');
    const [joining, setJoining] = useState(false);

    return (
        <Stack spacing={2}>
            {
                judgeCode && <Typography color="text.secondary">You've been invited to <b>judge</b> this hackathon. Judges score each team that presents, from 1 to 10 per category; the organizers can see who has scored, and your scores carry your name unless they made judging anonymous.</Typography>
            }
            {
                needsInviteCode && !judgeCode && (
                    <>
                        <Typography color="text.secondary">This hackathon is invite-only. Enter the code from your invitation.</Typography>
                        <Typography color="text.secondary" variant="body2">
                            Here to judge? You don't need the code: ask the organizer for the judge link, or to add you by email.
                        </Typography>
                        <TextField label="Invite code" value={inviteCode} onChange={(e) => {
                            setInviteCode(e.target.value);
                            setError('')
                        }} />
                    </>
                )
            }

            {
                error && <Alert severity='error'>{error}</Alert>
            }
            <Stack direction="row" spacing={2}>
                <Button onClick={() => {
                    if (joining) {
                        return false;
                    }
                    if (needsInviteCode && !judgeCode && !inviteCode.trim()) {
                        setError('Enter the invite code from your invitation');
                        return false;
                    }
                    setError('');
                    setJoining(true);
                    joinHackathon(hackathonId, inviteCode.trim(), judgeCode).then(() => {
                        window.location.reload();
                        setJoining(false);
                    }, (err) => {
                        const message = err.response?.data.message || 'An error occurred';
                        setError(message === 'Invalid invite code'
                            ? "That invite code didn't match. Check it against your invitation and try again."
                            : message);
                        setJoining(false);
                    });
                }} variant="contained" size="large" disabled={joining}>{judgeCode ? 'Join as a judge' : 'Join hackathon'}</Button>
            </Stack>
        </Stack>
    )
}
